import { ContainedModal } from '@carvana/showroom-modal';
import styled from 'styled-components';
import '@carvana/showroom-modal/index.css';

export const ModalContent = styled.div`
  padding: 2em 6em 3em 6em;
  text-align: center;
`;

export const ModalWrapper = styled(ContainedModal)`
  width: 100vw;
  position: absolute;
  right: 0;
  top: 0;

  @media (min-width: ${(props: any) => props.theme.breakpoint.sm}px) {
    width: 375px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  text-transform: none;
  padding-top: 2em;
  > button {
    flex: 0 0 48%;
  }
`;

export const ModalTitle = styled.p`
  margin: 0;
  color: var(--cvna-color-blue-6);
  font-size: 22px;
  font-weight: 600;
  line-height: 22px;
`;

export const ModalText = styled.p`
  margin: 0.75em;
  color: var(--cvna-color-grey-5);
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  padding: 0px 6em;
`;

export const Link = styled.a`
  color: var(--cvna-color-blue-2);
  text-decoration: none;
  :hover {
    color: var(--cvna-color-blue-3);
  }
`;
